/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAgentChart extends models.BaseForAgentResponse {
    constructor() {
        super();
        this.setDiscriminator("Chart");
    }

    getFixupPrototypeFunction() { return ResponseForAgentChart.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAgentChart>): ResponseForAgentChart {
        let obj = Object.assign(new ResponseForAgentChart(), model);
        ResponseForAgentChart.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAgentChart>): ResponseForAgentChart {
        if (!model) return null;
        return ResponseForAgentChart.newInstance(<ResponseForAgentChart> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAgentChart) {
        if (!obj) return;

        models.ResponseForAgentChart.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAgentChart): boolean {
        if (models.BaseForAgentResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResponseForAgentChart.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.value) {
            models.AgentChartData.fixupPrototype(this.value);
        }
    }

    /**
     * Chat response
     */
    value: models.AgentChartData;

}
